// eslint-ignore
export default 
`<Checkbox text="Small" size="sm"></Checkbox>
<Checkbox text="Default"></Checkbox>
<Checkbox text="Large" size="lg"></Checkbox>

export default {
  components: {
    Checkbox
  },
}`;